"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RELAYER_EVENTS = exports.RELAYER_CONTEXT = exports.RELAYER_DEFAULT_RPC_URL = exports.RELAYER_DEFAULT_PROTOCOL = exports.RELAYER_DEFAULT_PUBLISH_TTL = void 0;
const time_1 = require("./time");
exports.RELAYER_DEFAULT_PUBLISH_TTL = time_1.SIX_HOURS;
exports.RELAYER_DEFAULT_PROTOCOL = "waku";
exports.RELAYER_DEFAULT_RPC_URL = "wss://relay.walletconnect.org";
exports.RELAYER_CONTEXT = "relayer";
exports.RELAYER_EVENTS = {
    connect: "relayer_connect",
    disconnect: "relayer_disconnect",
    error: "relayer_error",
};
//# sourceMappingURL=relayer.js.map